import { render, staticRenderFns } from "./GlobalSnackbar.vue?vue&type=template&id=7cbffbca&scoped=true&"
import script from "./GlobalSnackbar.vue?vue&type=script&lang=js&"
export * from "./GlobalSnackbar.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSnackbar.vue?vue&type=style&index=0&id=7cbffbca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbffbca",
  null
  
)

component.options.__file = "GlobalSnackbar.vue"
export default component.exports